import { Transaction, BalanceData } from "@/types/transaction";

const now = new Date();

export const generateMockTransactions = (): Transaction[] => [
  {
    id: "1",
    type: "income",
    category: "Salary",
    amount: 5000,
    date: new Date(now.getTime() - 6 * 24 * 60 * 60 * 1000),
    description: "Monthly salary",
  },
  {
    id: "2",
    type: "expense",
    category: "Groceries",
    amount: 145.50,
    date: new Date(now.getTime() - 5 * 24 * 60 * 60 * 1000),
    description: "Weekly shopping",
  },
  {
    id: "3",
    type: "expense",
    category: "Utilities",
    amount: 200,
    date: new Date(now.getTime() - 4 * 24 * 60 * 60 * 1000),
    description: "Electric bill",
  },
  {
    id: "4",
    type: "income",
    category: "Freelance",
    amount: 1200,
    date: new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000),
    description: "Project payment",
  },
  {
    id: "5",
    type: "expense",
    category: "Dining",
    amount: 85.75,
    date: new Date(now.getTime() - 2 * 24 * 60 * 60 * 1000),
    description: "Restaurant",
  },
  {
    id: "6",
    type: "income",
    category: "Interest",
    amount: 50,
    date: new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000),
    description: "Monthly interest",
  },
  {
    id: "7",
    type: "expense",
    category: "Transport",
    amount: 60,
    date: new Date(now),
    description: "Gas",
  },
];

export const generateMockBalanceData = (
  transactions: Transaction[]
): BalanceData[] => {
  const balanceData: BalanceData[] = [];
  let balance = 8000;

  for (let i = 6; i >= 0; i--) {
    const date = new Date(now);
    date.setDate(date.getDate() - i);
    balanceData.push({ date, balance });

    const dayTransactions = transactions.filter((t) => {
      const tDate = new Date(t.date);
      return (
        tDate.toDateString() === date.toDateString()
      );
    });

    dayTransactions.forEach((t) => {
      balance += t.type === "income" ? t.amount : -t.amount;
    });
  }

  return balanceData;
};
